var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"h3"},[_vm._v("Filas de Tarefas")]),(_vm.listagemDeTarefas.length)?_c('SGPTabelaComponent',{attrs:{"filtroText":true,"colunas":_vm.colunas,"dados":_vm.listagemDeTarefas,"aceitaHtml":"","somenteLeitura":""}}):_c('SGPAlertaComponent'),(_vm.loadingPcoTarefas)?_c('SGPLoadingComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }